import C from "../actionTypes";

export const unionMembers = (state = {}, action) => {
    switch (action.type) {
        case C.UNION_MEMBERS_SUCCESS:
            return {...state, approved: action.clubs};
        case C.UNION_PENDINGS_SUCCESS:
            return {...state, pending: action.clubs};
        default:
            return state
    }
};